import Vue from 'vue';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import {
  Form,
  FormItem,
  Input,
  Option,
  Select,
  Switch,
} from 'element-ui';

locale.use(lang);

Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Input.name, Input);
Vue.component(Option.name, Option);
Vue.component(Select.name, Select);
Vue.component(Switch.name, Switch);
